import { createTheme } from "@mui/material/styles";
import { lightPalette } from "./palette";
import { buildComponents } from "./components";
import { buildShadows } from "./shadows";
import { typography, fontMono } from "./typography";

const lightTheme = createTheme({
  palette: lightPalette,
  typography,
  shape: { borderRadius: 12 },
  shadows: buildShadows("light"),
  components: buildComponents(lightPalette),
  custom: { fontMono },
});

export default lightTheme;
